import classNames from 'classnames';
import React from 'react';
import styles from './CallOut.module.scss';

interface CallOutProps {
  children: React.ReactNode;
  variant?: 'danger' | 'info' | 'success' | 'warning';
}

const CallOut = ({ children, variant = 'info' }: CallOutProps) => {
  return (
    <div className={classNames(styles.callOut, styles[variant])}>
      {children}
    </div>
  );
};

export default CallOut;
